import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { User } from "~/common/Store/connectUserAndChat";
import { VirtualGroupingVariation } from "./VirtualGroupingModel";
import isActiveSale from "../Pricing/isActiveSale";
import getLowestPrice from "../Pricing/getLowestPrice";

const getVirtualGroupingDropdownItemPricing = (
  vgItem: VirtualGroupingVariation,
  user: User,
  isGoogleView: boolean,
) => {
  const {
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
    minimumCustomizationPrice,
    maximumCustomizationPrice,
    customizationRequired,
  } = vgItem;

  let lowestPrice = getLowestPrice(
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
    user,
    true,
  );

  if (minimumCustomizationPrice && customizationRequired) {
    lowestPrice = minimumCustomizationPrice;
  }
  if (isGoogleView && maximumCustomizationPrice && customizationRequired) {
    lowestPrice = maximumCustomizationPrice;
  }

  const formattedLowestPrice = formatAsCurrency.formatIfUndefined(lowestPrice);

  const formattedP1Price = formatAsCurrency.formatIfUndefined(price.price);

  /* isActiveSale checks if displaySalePrice (Note: In display sale price catalog already checks if sale price is less then P1 price)
    is true and if the start and end dates are within the correct window. */
  const isOnSale = isActiveSale(price);

  const SaleIsTheLowestPrice = price.salePrice <= lowestPrice;

  const MapIsTheLowestPrice =
    price.minimumAdvertisedPriceProperties.price <= lowestPrice;

  const mapStyle = price.minimumAdvertisedPriceProperties.type.trim();

  const mapStyleWithHiddenPrice = ["C", "E", "M", "P", "W"];

  const shouldHidePrice = mapStyleWithHiddenPrice.includes(mapStyle);

  const hasMapStyle = price.minimumAdvertisedPriceProperties && !!mapStyle;

  const lowestPriceText = ` - ${formattedLowestPrice}`;

  const salePricingText = ` - ${formattedLowestPrice} Sale (reg. ${formattedP1Price})`;

  if (shouldHidePrice && hasMapStyle && MapIsTheLowestPrice) {
    return "";
  }

  if (isOnSale && SaleIsTheLowestPrice) {
    return salePricingText;
  }

  return lowestPriceText;
};

export default getVirtualGroupingDropdownItemPricing;
